import React from "react"

const ErrorPopup = (props) => {
  return (
    <div className="error-panel-wrapper">
      <div className="error-panel-sign">
        <div className="error-panel-image">
        </div>
      </div>
      <div className="error-panel-main-text">
        <p>
          Error
        </p>
      </div>
      <div className="error-panel-text">
        <p>
          Clock in can only be accessed at the location of the facility
        </p>
      </div>
      <div className="error-panel-button">
        <button className="close-error-button" onClick={props.onClickCancel}>Close</button>
      </div>
    </div>
  )
}

export default ErrorPopup
